export const parsePhoneNumber = (phoneNumber: string) => {
  phoneNumber = phoneNumber?.trim();
  return phoneNumber?.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
};

export const removePlusSignFromPhoneNumber = (phoneNumber: string) => {
  return phoneNumber?.startsWith('+') ? phoneNumber.slice(1) : phoneNumber;
};
